import * as React from "react";
import { useState, useContext, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import {ValueContext} from '~common/components/form-def-field-fc';
import {EditorState, ContentState, convertToRaw} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import {ICGFormControl} from '~common/components/icg-form-control';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    editor: {
        border: '1px solid #ccc',
        padding: 15,
        height: 400,
        width: "100%"
    },
    editorWarn: {
        border: '1px solid #ffe002',
        padding: 15,
        height: 400,
        width: "100%"
    },
    editorError: {
        border: '1px solid #d32f2f',
        padding: 15,
        height: 400,
        width: "100%"
    },
    editorHistory: {
        border: '1px solid #1614b3',
        padding: 15,
        height: 400,
        width: "100%"
    },
    wrapper: {
        width: "100%"
    },
    displayText: {
        // marginTop: 16,
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
  })
);

interface RichTextProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
}

// ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history']
const defaultToolbarOptions = {
    options: ['inline', 'link', 'image'],
}

export const RichTextField: React.FC<RichTextProps> = ({
  fieldDefinition,
  policyMessages,
  readOnlyOverride,
}) => {
    const classes = useStyles();    

    var parentContext = ValueContext
    
    const [fieldValue, setFieldValue] = useContext(parentContext);
    const [editorState, setEditorState] = useState(EditorState.createEmpty())

    let readOnly: boolean = (fieldDefinition.mode == "Read Only" || fieldDefinition.mode == "Display") ? true : false
    if (readOnlyOverride) {
      readOnly = true
    }

    const onEditorStateChange = (editState) => {
        setEditorState(editState)
        var fv = draftToHtml(convertToRaw(editState.getCurrentContent()))
        console.log("fv", fv)
        setFieldValue(fv)

    }
    
    var toolBarOptions = defaultToolbarOptions
    if(fieldDefinition.richTextOptions && fieldDefinition.richTextOptions.toolBarOptions){
        toolBarOptions = {options: fieldDefinition.richTextOptions.toolBarOptions}
    }

    let editorClass = classes.editor
    if (policyMessages && policyMessages.length > 0) {
        switch (policyMessages[0].severity) {
            case 1:
                editorClass = classes.editorWarn;
                break;
            case 2:
                editorClass = classes.editorError;
                break;
            case 4:
                editorClass = classes.editorHistory;
                break
          }
    }

    useEffect(() => {
        const blocksFromHtml = htmlToDraft(fieldValue || '')
        const {contentBlocks, entityMap} = blocksFromHtml
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
        const editState = EditorState.createWithContent(contentState);
        setEditorState(editState)        
    }, [])  
    // console.log(fieldDefinition)
    // console.log(classes.displayText)
    
    return (
        <ICGFormControl 
            fieldDefinition={fieldDefinition} 
            policyMessages={policyMessages} 
            readOnlyOverride={readOnlyOverride} 
            > 
            <div name={fieldDefinition.key}>
                {!readOnly && <Editor
                    editorState={editorState}
                    wrapperClassName={classes.wrapper}
                    editorClassName={editorClass}
                    onEditorStateChange={onEditorStateChange}
                    toolbar={toolBarOptions}
                />}
                {readOnly && fieldValue && <div style={fieldDefinition.styleAttributes} className={fieldDefinition.styleAttributes == null ? classes.displayText : ''}  dangerouslySetInnerHTML={{ __html: fieldValue }}/>}
            </div>
        </ICGFormControl>
       
    );
};

export default RichTextField;
